// Auth API client — Phase 1 Plan 05.
//
// POST /api/v1/auth/exchange-init-data and POST /api/v1/auth/refresh endpoints.
// Both return shape { access_token, refresh_token, expires_in, token_type }.

export interface AuthResponse {
  access_token: string;
  refresh_token: string;
  expires_in: number;
  token_type: string;
}

/**
 * Exchange validated initData → JWT + refresh token.
 *
 * @param baseUrl - API base URL
 * @param initDataRaw - raw query string from @telegram-apps/sdk-react launchParams
 */
export async function exchangeInitData(
  baseUrl: string,
  initDataRaw: string,
): Promise<AuthResponse> {
  const res = await fetch(`${baseUrl}/api/v1/auth/exchange-init-data`, {
    method: "POST",
    headers: {
      "X-Init-Data": initDataRaw,
      Accept: "application/json",
    },
  });
  if (!res.ok) {
    throw new Error(`Auth exchange failed: ${res.status} ${res.statusText}`);
  }
  return (await res.json()) as AuthResponse;
}

/**
 * Atomically rotate refresh token → new access + new refresh.
 *
 * Server-side `redis.getdel` ensures token is invalidated on first use; second
 * attempt returns 401 (reuse detection).
 */
export async function refreshAccess(baseUrl: string, refreshToken: string): Promise<AuthResponse> {
  const res = await fetch(`${baseUrl}/api/v1/auth/refresh`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Accept: "application/json",
    },
    body: JSON.stringify({ refresh_token: refreshToken }),
  });
  if (!res.ok) {
    throw new Error(`Refresh failed: ${res.status}`);
  }
  return (await res.json()) as AuthResponse;
}
